var map = {
	".": "NLtr",
	"./": "NLtr",
	"./01_get_currentTrack": "lgiQ",
	"./01_get_currentTrack.json": "lgiQ",
	"./02_post_close_currentTrack": "TSOU",
	"./02_post_close_currentTrack.json": "TSOU",
	"./03_post_tpsl_currentTrack": "UWbd",
	"./03_post_tpsl_currentTrack.json": "UWbd",
	"./05_swap_trader_detail": "ds0K",
	"./05_swap_trader_detail.json": "ds0K",
	"./06_swap_trader_profit_summary": "4DDS",
	"./06_swap_trader_profit_summary.json": "4DDS",
	"./07_swap_trader_profit_detail": "eNxZ",
	"./07_swap_trader_profit_detail.json": "eNxZ",
	"./08_swap_trader_set_commission": "7lDL",
	"./08_swap_trader_set_commission.json": "7lDL",
	"./09_swap_trader_trading_pair": "fvxU",
	"./09_swap_trader_trading_pair.json": "fvxU",
	"./index": "NLtr",
	"./index.js": "NLtr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0jZx";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/copyTrade/api/pFuturesTrader ^.*$
// module id = 0jZx
// module chunks = 3